import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

// Interview prep used to live under /flowstate/*. That prefix now belongs to the
// FlowState homepage, so old links and bookmarks are forwarded to /interview-prep.
const LegacyPrepRedirect = () => {
  const { "*": rest = "" } = useParams();
  const { search, hash } = useLocation();
  return <Navigate to={`/interview-prep/${rest}${search}${hash}`} replace />;
};

export default LegacyPrepRedirect;
